import React from 'react'

// import { Alerts } from 'views/layouts'

function Global() {
  return <></>
}

export default Global
